import React, { useEffect } from 'react';

import { LinkButton } from '@adsk/alloy-react-button';
import EmptyState from '@adsk/alloy-react-empty-state';

import { useFormsContext } from './FormsProvider';
import { ACTIONS } from './helpers/reducers/forms';
import { useTranslation } from './i18n';

const FormsCustomPickerNoSearchResults = ({ clearFilters, dataViewProps }) => {
  const { t } = useTranslation();
  const { dispatch } = useFormsContext();
  useEffect(() => {
    dispatch({
      type: ACTIONS.UPDATE_FORM_TEMPLATE_CATEGORIES,
      payload: {
        templateCategories: dataViewProps?.templateCategories || [],
      },
    });
  }, [dispatch, dataViewProps]);

  return (
    <EmptyState
      illustrationType={EmptyState.ILLUSTRATION_TYPES.CLIPBOARD_WEATHER_GREY}
      title={t('NO_FORMS_FOUND')}
      description={t('TRY_SEARCH_AGAIN')}
    >
      <LinkButton onClick={clearFilters}>{t('CLEAR_SEARCH')}</LinkButton>
    </EmptyState>
  );
};

export default FormsCustomPickerNoSearchResults;
